<div class="sph-konteyner">
  <!-- WebGPU Canvas Area -->
  <div class="sph-canvas-alan">
    <canvas #sphCanvas class="sph-canvas"></canvas>

    <!-- WebGPU not supported overlay -->
    <div class="webgpu-hata" *ngIf="webgpuHata">
      <i nz-icon nzType="warning" nzTheme="outline"></i>
      <p>{{ webgpuHata }}</p>
    </div>

    <!-- Loading overlay -->
    <div class="yukleniyor" *ngIf="yukleniyor">
      <i nz-icon nzType="loading" nzTheme="outline" class="yukleniyor-spinner"></i>
      <p>WebGPU hazırlanıyor...</p>
    </div>

    <!-- Canvas top-left overlay: compact stats -->
    <div class="canvas-bilgi" *ngIf="!webgpuHata && !yukleniyor">
      <span>{{ fps }} FPS</span>
      <span>{{ parcacikSayisi | number }} P</span>
      <span>{{ solverTipi }}</span>
    </div>
  </div>

  <!-- Control Panel -->
  <div class="sph-panel">
    <!-- Toolbar -->
    <div class="sph-toolbar">
      <button nz-button nzType="primary" nzSize="small" [disabled]="durum === 'calisiyor'" (click)="baslat()">
        <i nz-icon nzType="play-circle"></i>
      </button>
      <button nz-button nzSize="small" (click)="duraklat()">
        <i nz-icon [nzType]="durum === 'duraklatildi' ? 'play-circle' : 'pause-circle'"></i>
      </button>
      <button nz-button nzSize="small" [disabled]="durum === 'bosta'" (click)="durdur()">
        <i nz-icon nzType="stop"></i>
      </button>
      <button nz-button nzSize="small" (click)="sifirla()">
        <i nz-icon nzType="reload"></i>
      </button>

      <nz-divider nzType="vertical"></nz-divider>

      <span class="durum-badge" [class.aktif]="durum === 'calisiyor'">
        {{ durum === 'calisiyor' ? 'CALISIYOR' : durum === 'duraklatildi' ? 'DURAKLADI' : 'BOSTA' }}
      </span>

      <span class="istatistik">{{ fps }} FPS</span>
      <span class="istatistik">{{ parcacikSayisi | number }} P</span>
      <span class="istatistik">{{ simZaman.toFixed(1) }}s</span>
    </div>

    <!-- Tabs -->
    <nz-tabs nzSize="small" nzTabPosition="top" class="sph-tabs">
      <!-- Kontrol Tab -->
      <nz-tab nzTitle="Kontrol">
        <div class="tab-icerik">
          <!-- Solver -->
          <div class="param-grup">
            <label>Solver</label>
            <nz-select [(ngModel)]="solverTipi" (ngModelChange)="solverDegistir()" nzSize="small" style="width:100%">
              <nz-option *ngFor="let s of solverSecenekleri" [nzValue]="s.deger" [nzLabel]="s.etiket"></nz-option>
            </nz-select>
          </div>

          <!-- Kalite -->
          <div class="param-grup">
            <label>Kalite</label>
            <nz-select [(ngModel)]="kalite" (ngModelChange)="kaliteDegistir()" nzSize="small" style="width:100%">
              <nz-option *ngFor="let k of kaliteSecenekleri" [nzValue]="k.deger" [nzLabel]="k.etiket"></nz-option>
            </nz-select>
          </div>

          <!-- Malzeme -->
          <div class="param-grup">
            <label>Malzeme</label>
            <nz-select [(ngModel)]="seciliMalzeme" (ngModelChange)="malzemeDegistir()" nzSize="small" nzShowSearch style="width:100%">
              <nz-option *ngFor="let m of malzemeListesi" [nzValue]="m.ad" [nzLabel]="m.etiket"></nz-option>
            </nz-select>
          </div>

          <!-- Hiz -->
          <div class="param-grup">
            <label>Sim Hizi: {{ simHizi.toFixed(1) }}x</label>
            <nz-slider [(ngModel)]="simHizi" (ngModelChange)="hizDegistir()" [nzMin]="0.1" [nzMax]="4" [nzStep]="0.1"></nz-slider>
          </div>

          <nz-divider nzDashed></nz-divider>

          <!-- Fizik -->
          <h4 class="bolum-baslik">Fizik</h4>
          <div class="param-grup">
            <label>Cekim Y</label>
            <nz-input-number [(ngModel)]="gravityY" (ngModelChange)="fizikGuncelle()" [nzMin]="-20" [nzMax]="20" [nzStep]="0.1" nzSize="small" style="width:100%"></nz-input-number>
          </div>
          <div class="param-grup">
            <label>Viskozite</label>
            <nz-input-number [(ngModel)]="viskozite" (ngModelChange)="fizikGuncelle()" [nzMin]="0" [nzMax]="10" [nzStep]="0.0001" nzSize="small" style="width:100%"></nz-input-number>
          </div>
          <div class="param-grup">
            <label>Yuzey Gerilimi</label>
            <nz-input-number [(ngModel)]="yuzeyGerilimi" (ngModelChange)="fizikGuncelle()" [nzMin]="0" [nzMax]="1" [nzStep]="0.001" nzSize="small" style="width:100%"></nz-input-number>
          </div>
          <div class="param-grup">
            <label>Dinlenme Densitesi</label>
            <nz-input-number [(ngModel)]="dinlenmeDensitesi" (ngModelChange)="fizikGuncelle()" [nzMin]="100" [nzMax]="15000" [nzStep]="10" nzSize="small" style="width:100%"></nz-input-number>
          </div>
          <div class="param-grup">
            <label>Sinir Sonumleme</label>
            <nz-slider [(ngModel)]="sinirSonumleme" (ngModelChange)="fizikGuncelle()" [nzMin]="0" [nzMax]="1" [nzStep]="0.01"></nz-slider>
          </div>

          <nz-divider nzDashed></nz-divider>

          <!-- Render -->
          <h4 class="bolum-baslik">Gosterim</h4>
          <nz-radio-group [(ngModel)]="renderModu" (ngModelChange)="renderModuDegistir()" nzSize="small">
            <label *ngFor="let mod of renderModuSecenekleri" nz-radio [nzValue]="mod.deger">{{ mod.etiket }}</label>
          </nz-radio-group>
        </div>
      </nz-tab>

      <!-- Elemanlar Tab -->
      <nz-tab nzTitle="Elemanlar">
        <div class="tab-icerik">
          <div class="eleman-agaci">
            <div *ngFor="let kategori of elemanKategorileri" class="kategori">
              <div class="kategori-baslik" (click)="kategoriGeniletKapat(kategori.id)">
                <i nz-icon [nzType]="kategoriGenisletildiMi(kategori.id) ? 'caret-down' : 'caret-right'" class="ok-ikon"></i>
                <i nz-icon [nzType]="kategori.ikon" class="kategori-ikon"></i>
                <span class="kategori-ad">{{ kategori.ad }}</span>
                <nz-badge [nzCount]="kategori.elemanlar.length" nzShowZero [nzStyle]="{ backgroundColor: '#4ecca3', fontSize: '10px' }"></nz-badge>
                <button nz-button nzType="text" nzSize="small" (click)="elemanEkle(kategori.id); $event.stopPropagation()">
                  <i nz-icon nzType="plus"></i>
                </button>
              </div>

              <div class="kategori-icerik" *ngIf="kategoriGenisletildiMi(kategori.id)">
                <div *ngFor="let el of kategori.elemanlar"
                     class="eleman-satir"
                     [class.secili]="seciliEleman?.id === el.id"
                     (click)="elemanSec(el)">
                  <span class="eleman-ad">{{ el.ad }}</span>
                  <nz-tag *ngIf="el.aktif" nzColor="green" class="eleman-durum">ON</nz-tag>
                  <nz-tag *ngIf="!el.aktif" nzColor="default" class="eleman-durum">OFF</nz-tag>
                  <i nz-icon nzType="delete" class="sil-btn" (click)="elemanSil(el.id); $event.stopPropagation()"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- Secili Eleman Detay -->
          <div *ngIf="seciliEleman" class="secili-panel">
            <nz-divider nzDashed></nz-divider>
            <fiko-sph-eleman-panel
              [eleman]="seciliEleman"
              (elemanDegisti)="elemanDegisti($event)"
              (elemanSilindi)="elemanSilindi($event)">
            </fiko-sph-eleman-panel>
          </div>
        </div>
      </nz-tab>

      <!-- Timeline Tab -->
      <nz-tab nzTitle="Zaman">
        <div class="tab-icerik">
          <fiko-sph-timeline
            [simZaman]="simZaman"
            [simHizi]="simHizi"
            [durum]="durum"
            (hizDegisti)="hizDegistiHandler($event)"
            (senaryoSecildi)="senaryoSecildiHandler($event)">
          </fiko-sph-timeline>
        </div>
      </nz-tab>

      <!-- Analiz Tab -->
      <nz-tab nzTitle="Analiz">
        <div class="tab-icerik">
          <!-- Istatistikler -->
          <div class="ist-grid">
            <div class="ist-kutu">
              <span class="ist-etiket">FPS</span>
              <span class="ist-deger">{{ fps }}</span>
            </div>
            <div class="ist-kutu">
              <span class="ist-etiket">Parcacik</span>
              <span class="ist-deger">{{ parcacikSayisi | number }}</span>
            </div>
            <div class="ist-kutu">
              <span class="ist-etiket">Dolum</span>
              <span class="ist-deger">%{{ dolumYuzdesi.toFixed(1) }}</span>
            </div>
            <div class="ist-kutu">
              <span class="ist-etiket">Zaman</span>
              <span class="ist-deger">{{ simZaman.toFixed(2) }}s</span>
            </div>
          </div>

          <nz-divider nzDashed></nz-divider>

          <fiko-sph-analiz-panel
            [istatistikler]="istatistikler"
            [sensorVerileri]="sensorVerileri"
            (heatmapSecildi)="heatmapSecildiHandler($event)"
            (raporOlustur)="raporOlusturHandler()">
          </fiko-sph-analiz-panel>
        </div>
      </nz-tab>
    </nz-tabs>
  </div>
</div>
